import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import store from '@/store'
import { ACCESS_REQUIREMENTS, canAccessRequirement, resolveDefaultHomePath } from '@/utils/permission'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '仪表盘', icon: 'dashboard', activeMenu: '/dashboard', ...ACCESS_REQUIREMENTS.DASHBOARD }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: '',
        name: 'User',
        component: () => import('@/views/user/index'),
        meta: { title: '用户管理', icon: 'user', activeMenu: '/user', ...ACCESS_REQUIREMENTS.USER }
      }
    ]
  },
  {
    path: '/history',
    component: Layout,
    children: [
      {
        path: '',
        name: 'History',
        component: () => import('@/views/history/index'),
        meta: { title: '历史会话', icon: 'message', activeMenu: '/history', ...ACCESS_REQUIREMENTS.HISTORY }
      }
    ]
  },
  {
    path: '/sensitive',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Sensitive',
        component: () => import('@/views/sensitive/index'),
        meta: { title: '敏感词库管理', icon: 'lock', activeMenu: '/sensitive', ...ACCESS_REQUIREMENTS.SENSITIVE }
      }
    ]
  },
  {
    path: '/basic',
    component: Layout,
    redirect: '/basic/agreement',
    meta: { title: '基础管理', icon: 'el-icon-setting', ...ACCESS_REQUIREMENTS.BASIC },
    children: [
      {
        path: 'agreement',
        name: 'Agreement',
        component: () => import('@/views/basic/index'),
        meta: { title: '用户协议', icon: 'documentation', ...ACCESS_REQUIREMENTS.BASIC }
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('@/views/basic/index'),
        meta: { title: '隐私协议', icon: 'lock', ...ACCESS_REQUIREMENTS.BASIC }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/basic/index'),
        meta: { title: '关于我们', icon: 'info', ...ACCESS_REQUIREMENTS.BASIC }
      },
      {
        path: 'customer-service',
        name: 'CustomerService',
        component: () => import('@/views/basic/index'),
        meta: { title: '客服管理', icon: 'el-icon-service', ...ACCESS_REQUIREMENTS.BASIC }
      }
    ]
  },
  {
    path: '/knowledge',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Knowledge',
        component: () => import('@/views/knowledge/index'),
        meta: { title: '知识库管理', icon: 'el-icon-reading', ...ACCESS_REQUIREMENTS.KNOWLEDGE }
      }
    ]
  },
  {
    path: '/official-file',
    component: Layout,
    children: [
      {
        path: '',
        name: 'OfficialFile',
        component: () => import('@/views/official-file/index'),
        meta: { title: '官方文件管理', icon: 'el-icon-document', ...ACCESS_REQUIREMENTS.OFFICIAL_FILE }
      }
    ]
  },
  {
    path: '/rbac',
    component: Layout,
    hidden: true,
    redirect: '/rbac/permissions',
    children: [
      {
        path: 'permissions',
        name: 'RbacPermission',
        component: () => import('@/views/rbac-permission/index'),
        meta: { title: 'RBAC管理', ...ACCESS_REQUIREMENTS.RBAC }
      }
    ]
  },
  {
    path: '/403',
    component: () => import('@/views/error-page/403'),
    hidden: true
  },
  {
    path: '*',
    redirect: '/403',
    hidden: true
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const whiteList = ['/login']

router.beforeEach(async(to, from, next) => {
  const hasToken = store.getters.token

  if (hasToken) {
    const authState = () => ({
      isSuperAdmin: store.getters.isSuperAdmin,
      permissionCodes: store.getters.permissionCodes,
      menuKeys: store.getters.menuKeys
    })

    const resolveHomePath = () => resolveDefaultHomePath(authState(), store.getters.defaultHome)

    try {
      if (!store.getters.profileLoaded) {
        await store.dispatch('user/getInfo')
      }

      if (to.path === '/login') {
        next({ path: resolveHomePath() })
        return
      }

      if (to.path === '/') {
        next(resolveHomePath())
        return
      }

      const currentAuthState = authState()
      const matchedRoutes = to.matched.filter(route => route.meta)
      const hasPermission = matchedRoutes.every(route => canAccessRequirement(route.meta, currentAuthState))

      if (!hasPermission) {
        const fallbackPath = resolveHomePath()
        if (fallbackPath !== '/403' && fallbackPath !== to.path) {
          next(fallbackPath)
          return
        }
        next('/403')
        return
      }

      next()
    } catch (error) {
      await store.dispatch('user/resetToken')
      next(`/login?redirect=${to.path}`)
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router
